import { HtsReadinessPillarKey } from "../constants";
import { HtsReadinessPillarConfig } from "../schemas";

export const motivation: HtsReadinessPillarConfig = {
  key: HtsReadinessPillarKey.MOTIVATION,
  label: "Motivation",
  definition:
    "Commitment and dedication to the target career, evidenced by concrete preparation — not stated enthusiasm.",
  dataSourceNote:
    "Asked — one open question on preparation so far, with neutral follow-ups on gaps; claims of alignment are verified against the volunteering, education, work, and fitness data already scored.",
  dimensions: [
    {
      key: "knowledgeOfRoleAgency",
      label: "Knowledge of Role & Agency",
      weight: 0.25,
      anchors: {
        0: "No research; cannot describe the role or the agency beyond generalities.",
        25: "Basic online research only.",
        50: "Meaningful research including agency-specific requirements and values.",
        75: "Specific knowledge of the agency's hiring process, requirements, and stated values, from any source.",
        100: "Deep, current knowledge: agency values articulated in their own words, hiring process steps described accurately, and awareness of recent agency priorities. Sessions or contacts are one route to this level, not a requirement.",
      },
    },
    {
      key: "deliberatePreparationActions",
      label: "Deliberate Preparation Actions",
      weight: 0.45,
      anchors: {
        0: "Nothing done to date.",
        25: "Research only — no concrete action taken.",
        50: "One concrete application-specific step (prerequisite certification obtained, fitness test booked or completed, references identified, application requirements gathered, session attended).",
        75: "Multiple application-specific steps, or one step plus a related change in work or volunteering that postdates the career decision.",
        100: "Education, work, fitness, and volunteering all deliberately aligned toward the target career — and the alignment verifies against the other pillars.",
      },
    },
    {
      key: "sustainedCommitment",
      label: "Sustained Commitment",
      weight: 0.3,
      anchors: {
        0: "No preparation trajectory — the interest is brand new.",
        25: "Preparation began within the last month, with no related career history.",
        50: "A trajectory of 1–6 months.",
        75: "A trajectory of 6–12 months.",
        100: "A sustained trajectory of 12+ months, with steps that build on each other.",
      },
    },
  ],
  topIndicators: [
    "Preparation that predates the application",
    "Steps that required effort or a change in routine",
    "Alignment other pillars confirm",
  ],
  scoringNotes: [
    "Values common to all policing (honesty, integrity, courage, respect) count only as basic research (25), unless the answer ties them to the agency's own stated values or programs. Accuracy is not checked.",
    "Claims of full alignment are cross-verified against the Community Contribution/Education/Work/Fitness pillars' actual data, not the assertion.",
    "A related career of 3+ years counts as a trajectory of 12+ months regardless of when the decision to apply was made.",
  ],
};
